export enum IMessageTypeEnum {
  Warning = 0,
  Information = 1,
  Error = 2
}